import {
  listWorkspaces,
  loginByPassword,
  loginByThirdPartyIdp,
} from '@modusign/openapi-client-user';
import { LoginByThirdPartyIdpRequestDtoProvider } from '@modusign/openapi-client-user/model';

import authService, { Tokens } from '@app/libs/auth/authService';
import { logger } from '@app/libs/logger';
import workspaceService from '@app/libs/workspaceService';

/* prettier-ignore */
export const login = async (params: FetchAccessTokenParams) =>
  fetchAccessToken(params)
    .then(authService.setTokens);

export const loginToWorkspace = async (params: FetchAccessTokenParams) =>
  fetchAccessToken(params)
    .then(authService.setTokens)
    .then(() => setCurrentWorkspace({ type: 'PUBLIC' }));

type FetchAccessTokenParams =
  | { type: 'email'; email: string; password: string }
  | { type: 'oauth'; provider: LoginByThirdPartyIdpRequestDtoProvider; code: string }
  | { type: 'token'; tokens: Tokens };

async function fetchAccessToken(params: FetchAccessTokenParams) {
  let tokens: Tokens | null = null;

  try {
    switch (params.type) {
      case 'email':
        tokens = await loginByPassword(
          { email: params.email, password: params.password },
          { credentials: false }
        );
        break;
      case 'oauth':
        tokens = await loginByThirdPartyIdp(
          { provider: params.provider, code: params.code },
          { credentials: false }
        );
        break;
      case 'token':
        tokens = params.tokens;
        break;
      default:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        throw new Error(`login type ${params.type} is not supported`);
    }
  } catch (error) {
    logger.error(error.message, { context: 'login 도중 액세스토큰 발급 실패' }, error);
    throw error;
  }

  return tokens;
}

export async function setCurrentWorkspace({ type }: { type: 'PRIVATE' | 'PUBLIC' }) {
  const { workspaces } = await listWorkspaces();

  const target = workspaces.sort((w) => (w.type === type ? -1 : 1))[0];

  workspaceService.setWorkspaceId(target.id);
}
